import { createContext, useEffect, useState } from 'react';

interface TSToastStore {
    type: string;
    contents: string;
}

interface TSModalStoreButtons {
	readonly label: string;
	readonly color: string;
	readonly fn: () => void;
}

interface TSModalStore {
    title: null | string;
    contents: string | React.ReactNode;
	buttons: Array <TSModalStoreButtons>;
}



interface ContextProps {
	readonly toastStore: TSToastStore;
	readonly toast: ({type, contents}: TSToastStore) => void;
    readonly modalStore: TSModalStore;
    readonly modal: ({title, contents, buttons,}: TSModalStore) => void;
	
}

const UIContext = createContext<ContextProps> ({
	toast: ({type, contents}: TSToastStore) => {},
	toastStore: {
		type: 'FAILURE',
		contents: "init"
	},
	modal: ({title, contents, buttons}: TSModalStore) => {},
    modalStore: {
        title: 'init', 
        contents:'contents',
		buttons: [
			{
				label: 'confirm',
				color: 'red',
				fn: () => {}
			}
		]
    },

    /* eslint-enable @typescript-eslint/no-empty-function */
});


interface Props {
    children: JSX.Element | JSX.Element[];
}

const UIContextProvider = ({
	children
}: Props): JSX.Element => {

	//console.log('[UIContextProvider] Init')
	const [ toastStore, setToastStore ] = useState <TSToastStore> ({
		type: 'FAILURE',
		contents: "init"
	});

	const [ modalStore, setModalStore ] = useState <TSModalStore> ({
        title: 'init', 
        contents:'contents',
		buttons: [
			{
				label: 'cancel',
				color: 'red',
				fn: () => {}
			},
			{
				label: 'confirm',
				color: 'red',
				fn: () => {}
			}
		]
    });

	
	const toast = ({
        type,
        contents
    }: TSToastStore) => {
        setToastStore({
            type,
            contents,
        })
    };
    
	const modal = ({
        title,
        contents,
        buttons
    }: TSModalStore) => {
        setModalStore({
            title,
            contents,
			buttons
        })
    };

	


	useEffect(()=>{
		console.log('[UIContextProvider] Effect')
	}, [])
    
    
    const value = {
		toastStore,
		toast,
        modalStore,
        modal,
		
    };

    return (
        <UIContext.Provider value={value}>
            {children}
        </UIContext.Provider>
    );
};

export { UIContext, UIContextProvider };